import styled, { StyledComponentProps } from 'styled-components'
import { cssMediaQueryBreakpoints } from '../config/breakpoints'
import { NoSelectStyles } from '../shared/styled/NoSelectStyles.styled'

interface IProps {}

export const StyledNoSearchResultsIcon = (props: IProps & StyledComponentProps<'svg', any, {}, never>) => {
    return (
        <StyledSvg viewBox='0 0 65 64' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <path
                d='M41.1733 40.557L49.3422 49.9649M46.382 29.3333C46.382 37.4723 39.7556 44.0702 31.5814 44.0702C23.4072 44.0702 16.7808 37.4723 16.7808 29.3333C16.7808 21.1944 23.4072 14.5965 31.5814 14.5965C39.7556 14.5965 46.382 21.1944 46.382 29.3333Z'
                strokeWidth='3'
                strokeLinecap='round'
            />
            <path
                d='M28.0088 32.5614L34.7456 25.8245M28.0088 25.8245L34.7456 32.5614'
                strokeWidth='3'
                strokeLinecap='round'
            />
        </StyledSvg>
    )
}

const StyledSvg = styled.svg<IProps>`
    ${NoSelectStyles}

    stroke: ${p => p.stroke || p.theme.playColor};
    height: 114px;
    width: 114px;

    ${cssMediaQueryBreakpoints.medium} {
        height: 65px;
        width: 65px;
    }
`
